import type {ValueFragment} from "app/gql/graphqlSchema";
import {freeze} from "immer";

export const EMPTY_VALUE = freeze<Extract<ValueFragment, {__typename: "ControlCardEmptyValue"}>>({
  __typename: "ControlCardEmptyValue",
  dummy: null
});

export type EditComboBoxOptionOutcome<Option> = {success: true; option: Option} | {success: false};
